import React from 'react';
import VideoTest from '../components/VideoTest'; // Adjust path if needed

const VideoTestPage: React.FC = () => {
  // Mock question for standalone test route (stub; replace with real data if this becomes a full page)
  const mockQuestion = {
    id: '00000000-0000-0000-0000-000000000001', // Valid UUID
    text: 'Tell me about yourself (test mode)',
    timeLimit: 240, // Seconds
  };

  // Handler for upload success (logs for testing; expand later if needed)
  const handleUploadSuccess = (url: string) => {
    console.log('Test page video uploaded:', url);
    // Optional: Add alert or state for UI feedback
  };

  return (
    <div className="p-4 max-w-md mx-auto">
      <h1 className="text-2xl font-bold mb-4">Video Test Page</h1>
      <VideoTest 
        applicationId="test-application-id" // FIXED: Added required prop (use a real ID in production; this is for dev testing only)
        question={mockQuestion} 
        onUploadSuccess={handleUploadSuccess} 
      />
    </div>
  );
};

export default VideoTestPage;